import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import Service from "./../components/service";
import SectionContent from "./../scripts/sectionContent";

const Services = () => {

    const data = useStaticQuery(graphql`
        query servicesSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "Services"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
            allContentfulServices(sort: {fields: id, order: ASC}) {
                edges {
                    node {
                        id
                        title
                        description
                        price
                        buttonText
                        buttonUrl
                        serviceItems
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="services" className="services section text-center bg-gradient-primary">
            <div className="container mx-auto">
                <div className="flex flex-col">
                    <div className="col w-full md:w-1/2 mx-auto">
                        <h3 className="section__heading text-2xl  mx-auto mb-4">{ sectionContent.getContent('heading').rawMarkdownBody }</h3>
                        <p className="mb-16">{ sectionContent.getContent('description').rawMarkdownBody }</p>
                    </div>
                    <div className="col w-full lg:w-10/12 mx-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-16">
                            {
                                data.allContentfulServices.edges.map(edge => (
                                    <Service service={edge.node} key={ edge.node.id } />
                                ))
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Services;